import React from 'react';
import RedemptionWrapper from '../RedemptionWrapper';

const RollingRedemptionReportPage = function RollingRedemptionReportPage({
  userRoles,
}) {
  return <RedemptionWrapper userRoles={userRoles} isRolling />;
};

export default RollingRedemptionReportPage;
